import React from 'react';
import { Layout } from '@components/team';
import { EditServiceProvider as ServiceProviderEdit } from '@components/team';

const EditOthers = () => {
    return <ServiceProviderEdit />;
};
EditOthers.Layout = Layout;
export default EditOthers;
